import { css } from '@linaria/core';

export const DropdownElementWrapper = css`
	display: flex;
	gap: 12px;
	align-items: center;
	padding: 8px 16px;
	height: 40px;
	animation: fadein 200ms;

	&:hover {
		background-color: var(--color-white-01);
	}

	@keyframes fadein {
		0% {
			height: 0;
			padding-top: 0;
			padding-bottom: 0;
		}
		100% {
			height: 40px;
			padding-top: 8px;
			padding-bottom: 8px;
		}
	}
`;

export const PopoverWrapper = css`
	display: none;
	top: 0;
	left: 0;
	padding: 8px 0;
	width: max-content;
	background-color: var(--color-gray-07);
	opacity: 0;
	border: none;
	border-radius: 12px;
	outline: none;
	--transition-time: 0.3s;
	transform: scale(0.7);
	backdrop-filter: blur(6px);
	flex-direction: column;

	& .${DropdownElementWrapper} + .${DropdownElementWrapper} {
		margin-top: 1px;
		position: relative;
		&:before {
			top: -1px;
			right: 0;
			display: block;
			position: absolute;
			content: '';
			height: 1px;
			width: 100%;
			background-color: var(--color-white-01);
		}
	}

	&:popover-open {
		opacity: 1;
		display: flex;
		transform: none;
		transition: opacity var(--transition-time),
			transform var(--transition-time) ease-out,
			display var(--transition-time) allow-discrete;

		@starting-style {
			opacity: 0;
			transform: scale(0.7);
		}
	}
`;
